import { createContext, ReactNode } from 'react';

export interface HeaderContextType {
  headerContent: ReactNode;
  setHeaderContent: (content: ReactNode) => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextType>({
  headerContent: null,
  setHeaderContent: () => {},
  isLoading: false,
  setLoading: () => {},
});
